import React from 'react'

const RestablecerContrasena = () => {
  return (
    <div>RestablecerContrasena</div>
  )
}

export default RestablecerContrasena